import React, { Component } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { Player } from "video-react";
import videoPoster from "../../../Imgs/AboutUs/ManagerMessage/managerPosterVideo.PNG";
import LazyLoad from "react-lazyload";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/ManagerMessage/ManagerMessage.css";

const managerMessageCard = {
  borderRadius: "20px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
};

const Norooz = (props) => {
  return props.size === "laptopdesktop" ? (
    <div className="managerMessageBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>نوروز ۱۴۰۱</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription">
              پیام تبریک مدیرعامل ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={4}></Col>
        <Col span={16}>
          <div style={managerMessageCard}>
            <Row>
              <Col
                span={24}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                  <p className="textBoldParagraph">
                    نوروز باستانی و سال نو بر همه ایرانیان مبارک باد
                    <br />
                  </p>
                  <p className="textParagraph">
                    با وجود سایه شوم ویروس کرونا بر این مرز و بوم اهورایی، خدای
                    را شکر میگوییم که ما را ارزش جان دانسته و تا به امروز اراده
                    اش بر بودنمان بوده است تا شرکت ایرانیان پوشش را سکانداری و
                    هدایت کنم تا همچنان امید بخش برای جامعه بیمه ای کشور باشد.
                    با وجود سنگلاخی شدن مسیر کسب وکارها در یک سال گذشته، به لطف
                    خدا و با تلاش مسئولانه پرسنل و همکاران، همچنان بر سر سفره
                    ایرانیان پوشش برکت بوده است و کسان زیادی از این برکت بهره
                    برده اند. این دستاوردها را همراه با بهار ١٤٠١ به تمام ملت
                    بزرگ ایران و بویژه خانواده ایرانیان پوشش و شرکت های زیر
                    مجموعه تبریک و شادباش میگویم.
                    <br />
                    سال۱۴۰۱ ایرانیان پوشش وارد ده سالگی خواهد شود و انشاالله در
                    ۱۳ اذر سالروز تاسیس ده ساله خود را با هم جشن خواهیم گرفت در
                    این ده سال با تمام فراز و نشیب همیشه شکر گذار بودیم و خواهیم
                    ماند و دعا میکنیم که خدایا! به پاس تمام موهبت هایی که به ما
                    ارزانی داشته ای، سپاست میگوییم. تو را سپاس که به ما امکان
                    دادهای تا سفرهای گسترده شود و سرشار از برکت و نعمت گردد.
                    پروردگارا، به ما چشم دیدن الطاف بیکران و موهبت های خارج از
                    شمارتان را بدهید. پروردگارا! این کشور اهورایی را از شر و بد
                    روزگار دور کن، مردم با صفایش را از پریشانی و آشفتگی ها محفوظ
                    بدار و شادی و آرامش و زندگی سرشار از معنا را ارزانی بفرما.
                    پروردگارا! به ما امکان بده تا با موهبت های امید و ایمان به
                    نبرد با مشکلات کشور برویم و اقتصادمان را در ده سال دوم هم
                    آبادتر سازیم. پروردگارا! به ما امکان بده تا از مسیر توسعه
                    کسب وکارها و ایجاد فرصتهای شغلی پایدار در صنعت بیمه دلهای
                    مردم را شاد کنیم. پروردگارا به ما همچنان سلامت فکری و جسمی
                    ارزانی بفرما تا در سال ١٤٠١ نیز بتوانیم مراقب صنعت بیمه کشور
                    باشیم و از راه شرکت ایرانیان پوشش و شرکت های زیر مجموعه اش
                    به مقاوم سازی اقتصاد و امنیت بیشتر کشورمان کمک کنیم.
                    <br />
                    در پايان جا دارد كه از استظهار و اعتماد بيمه گران عزيز، بيمه
                    مركزي، سنديكاي بيمه گران تشكر و تقدير نمايم و همچنين از تمام
                    كاركنان و كارشناسان ستادي و شعبه شركت بابت زحمات شبانه روزي
                    نهايت تشكر و تقدير نمايم . قدر دان زحمات تان هستيم. به اميد
                    سالي سرشار از سلامتي و موفقيت براي خانواده بزرگ صنعت بيمه
                  </p>
                  <p className="textBoldParagraph">
                    باتجدید احترام
                    <br />
                    ابراهیم ایران نژاد مدیرعامل ایرانیان پوشش
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div className="managerMessageBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>نوروز ۱۴۰۱</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet">
              پیام تبریک مدیرعامل ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={managerMessageCard}>
            <Row>
              <Col
                span={24}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                  <p className="textBoldParagraph">
                    نوروز باستانی و سال نو بر همه ایرانیان مبارک باد
                    <br />
                  </p>
                  <p className="textParagraph">
                    با وجود سایه شوم ویروس کرونا بر این مرز و بوم اهورایی، خدای
                    را شکر میگوییم که ما را ارزش جان دانسته و تا به امروز اراده
                    اش بر بودنمان بوده است تا شرکت ایرانیان پوشش را سکانداری و
                    هدایت کنم تا همچنان امید بخش برای جامعه بیمه ای کشور باشد.
                    با وجود سنگلاخی شدن مسیر کسب وکارها در یک سال گذشته، به لطف
                    خدا و با تلاش مسئولانه پرسنل و همکاران، همچنان بر سر سفره
                    ایرانیان پوشش برکت بوده است و کسان زیادی از این برکت بهره
                    برده اند. این دستاوردها را همراه با بهار ١٤٠١ به تمام ملت
                    بزرگ ایران و بویژه خانواده ایرانیان پوشش و شرکت های زیر
                    مجموعه تبریک و شادباش میگویم.
                    <br />
                    سال۱۴۰۱ ایرانیان پوشش وارد ده سالگی خواهد شود و انشاالله در
                    ۱۳ اذر سالروز تاسیس ده ساله خود را با هم جشن خواهیم گرفت در
                    این ده سال با تمام فراز و نشیب همیشه شکر گذار بودیم و خواهیم
                    ماند و دعا میکنیم که خدایا! به پاس تمام موهبت هایی که به ما
                    ارزانی داشته ای، سپاست میگوییم. تو را سپاس که به ما امکان
                    دادهای تا سفرهای گسترده شود و سرشار از برکت و نعمت گردد.
                    پروردگارا، به ما چشم دیدن الطاف بیکران و موهبت های خارج از
                    شمارتان را بدهید. پروردگارا! این کشور اهورایی را از شر و بد
                    روزگار دور کن، مردم با صفایش را از پریشانی و آشفتگی ها محفوظ
                    بدار و شادی و آرامش و زندگی سرشار از معنا را ارزانی بفرما.
                    پروردگارا! به ما امکان بده تا با موهبت های امید و ایمان به
                    نبرد با مشکلات کشور برویم و اقتصادمان را در ده سال دوم هم
                    آبادتر سازیم. پروردگارا! به ما امکان بده تا از مسیر توسعه
                    کسب وکارها و ایجاد فرصتهای شغلی پایدار در صنعت بیمه دلهای
                    مردم را شاد کنیم. پروردگارا به ما همچنان سلامت فکری و جسمی
                    ارزانی بفرما تا در سال ١٤٠١ نیز بتوانیم مراقب صنعت بیمه کشور
                    باشیم و از راه شرکت ایرانیان پوشش و شرکت های زیر مجموعه اش
                    به مقاوم سازی اقتصاد و امنیت بیشتر کشورمان کمک کنیم.
                    <br />
                    در پايان جا دارد كه از استظهار و اعتماد بيمه گران عزيز، بيمه
                    مركزي، سنديكاي بيمه گران تشكر و تقدير نمايم و همچنين از تمام
                    كاركنان و كارشناسان ستادي و شعبه شركت بابت زحمات شبانه روزي
                    نهايت تشكر و تقدير نمايم . قدر دان زحمات تان هستيم. به اميد
                    سالي سرشار از سلامتي و موفقيت براي خانواده بزرگ صنعت بيمه
                  </p>
                  <p className="textBoldParagraph">
                    باتجدید احترام
                    <br />
                    ابراهیم ایران نژاد مدیرعامل ایرانیان پوشش
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  ) : (
    <div className="managerMessageBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>نوروز ۱۴۰۱</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile">
              پیام تبریک مدیرعامل ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <div>
        <Row style={{ marginTop: "25px" }}>
          <Col span={1}></Col>
          <Col span={22}>
            <div
              style={{
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                backgroundColor: "#fff",
                height: "100%",
                borderRadius: "20px",
              }}
            >
              <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px" }}>
                <Margin top={1}></Margin>
                <div
                  style={{
                    padding: "15px",
                    backgroundColor: "#fff",
                    borderRadius: "20px",
                  }}
                >
                  <p className="textBoldParagraph">
                    نوروز باستانی و سال نو بر همه ایرانیان مبارک باد
                    <br />
                  </p>
                  <p className="textParagraph">
                    با وجود سایه شوم ویروس کرونا بر این مرز و بوم اهورایی، خدای
                    را شکر میگوییم که ما را ارزش جان دانسته و تا به امروز اراده
                    اش بر بودنمان بوده است تا شرکت ایرانیان پوشش را سکانداری و
                    هدایت کنم تا همچنان امید بخش برای جامعه بیمه ای کشور باشد.
                    با وجود سنگلاخی شدن مسیر کسب وکارها در یک سال گذشته، به لطف
                    خدا و با تلاش مسئولانه پرسنل و همکاران، همچنان بر سر سفره
                    ایرانیان پوشش برکت بوده است و کسان زیادی از این برکت بهره
                    برده اند. این دستاوردها را همراه با بهار ١٤٠١ به تمام ملت
                    بزرگ ایران و بویژه خانواده ایرانیان پوشش و شرکت های زیر
                    مجموعه تبریک و شادباش میگویم.
                    <br />
                    سال۱۴۰۱ ایرانیان پوشش وارد ده سالگی خواهد شود و انشاالله در
                    ۱۳ اذر سالروز تاسیس ده ساله خود را با هم جشن خواهیم گرفت در
                    این ده سال با تمام فراز و نشیب همیشه شکر گذار بودیم و خواهیم
                    ماند و دعا میکنیم که خدایا! به پاس تمام موهبت هایی که به ما
                    ارزانی داشته ای، سپاست میگوییم. تو را سپاس که به ما امکان
                    دادهای تا سفرهای گسترده شود و سرشار از برکت و نعمت گردد.
                    پروردگارا، به ما چشم دیدن الطاف بیکران و موهبت های خارج از
                    شمارتان را بدهید. پروردگارا! این کشور اهورایی را از شر و بد
                    روزگار دور کن، مردم با صفایش را از پریشانی و آشفتگی ها محفوظ
                    بدار و شادی و آرامش و زندگی سرشار از معنا را ارزانی بفرما.
                    پروردگارا! به ما امکان بده تا با موهبت های امید و ایمان به
                    نبرد با مشکلات کشور برویم و اقتصادمان را در ده سال دوم هم
                    آبادتر سازیم. پروردگارا! به ما امکان بده تا از مسیر توسعه
                    کسب وکارها و ایجاد فرصتهای شغلی پایدار در صنعت بیمه دلهای
                    مردم را شاد کنیم. پروردگارا به ما همچنان سلامت فکری و جسمی
                    ارزانی بفرما تا در سال ١٤٠١ نیز بتوانیم مراقب صنعت بیمه کشور
                    باشیم و از راه شرکت ایرانیان پوشش و شرکت های زیر مجموعه اش
                    به مقاوم سازی اقتصاد و امنیت بیشتر کشورمان کمک کنیم.
                    <br />
                    در پايان جا دارد كه از استظهار و اعتماد بيمه گران عزيز، بيمه
                    مركزي، سنديكاي بيمه گران تشكر و تقدير نمايم و همچنين از تمام
                    كاركنان و كارشناسان ستادي و شعبه شركت بابت زحمات شبانه روزي
                    نهايت تشكر و تقدير نمايم . قدر دان زحمات تان هستيم. به اميد
                    سالي سرشار از سلامتي و موفقيت براي خانواده بزرگ صنعت بيمه
                  </p>
                  <p className="textBoldParagraph">
                    باتجدید احترام
                    <br />
                    ابراهیم ایران نژاد مدیرعامل ایرانیان پوشش
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col span={1}></Col>
        </Row>
      </div>
    </div>
  );
};

export default Norooz;
